import { render, staticRenderFns } from "./RestaurantProfile.vue?vue&type=template&id=0b07a2fb&scoped=true&"
import script from "./RestaurantProfile.vue?vue&type=script&lang=js&"
export * from "./RestaurantProfile.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantProfile.vue?vue&type=style&index=0&id=0b07a2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07a2fb",
  null
  
)

export default component.exports